module.exports = __webpack_public_path__ + "8348878b4843b9a6628ff0d51e08f92a.png";